/**
 * Catálogo comercial de tipos de licencia (solicitud comprador / emisión BNT).
 * No activa licencia ni sustituye plan=standard.
 */

export const LICENSE_TYPE_TRIAL_15_DAYS = "trial_15_days";
export const LICENSE_TYPE_MONTHLY = "monthly";
export const LICENSE_TYPE_SEMIANNUAL = "semiannual";
export const LICENSE_TYPE_ANNUAL = "annual";
export const LICENSE_TYPE_COURTESY_PERMANENT = "courtesy_permanent";

export const LICENSE_TYPE_LABELS = {
  [LICENSE_TYPE_TRIAL_15_DAYS]: "Prueba 15 días",
  [LICENSE_TYPE_MONTHLY]: "Mensual",
  [LICENSE_TYPE_SEMIANNUAL]: "Semestral",
  [LICENSE_TYPE_ANNUAL]: "Anual",
  [LICENSE_TYPE_COURTESY_PERMANENT]: "Cortesía / permanente",
};

export const LICENSE_TYPE_IDS = Object.keys(LICENSE_TYPE_LABELS);

/** Registro SaaS ya abre trial; solicitud inicial sugiere contrato anual. */
export const DEFAULT_REQUESTED_LICENSE_TYPE_INITIAL = LICENSE_TYPE_ANNUAL;
export const DEFAULT_REQUESTED_LICENSE_TYPE_RENEWAL = LICENSE_TYPE_ANNUAL;
export const DEFAULT_ISSUED_LICENSE_TYPE = LICENSE_TYPE_ANNUAL;

export const COURTESY_PERMANENT_VALID_TO = "2099-12-31";

const RENEWAL_REQUEST_TYPES = new Set([
  LICENSE_TYPE_MONTHLY,
  LICENSE_TYPE_SEMIANNUAL,
  LICENSE_TYPE_ANNUAL,
  LICENSE_TYPE_COURTESY_PERMANENT,
  LICENSE_TYPE_TRIAL_15_DAYS,
]);

/** @param {string} [code] */
export function licenseTypeLabel(code) {
  const key = String(code || "").trim().toLowerCase();
  return LICENSE_TYPE_LABELS[key] || key || "—";
}

/** @param {boolean} [hasActiveLicense] */
export function defaultRequestedLicenseType(hasActiveLicense = false) {
  return hasActiveLicense
    ? DEFAULT_REQUESTED_LICENSE_TYPE_RENEWAL
    : DEFAULT_REQUESTED_LICENSE_TYPE_INITIAL;
}

/** @param {boolean} [hasActiveLicense] */
export function requestedLicenseTypeOptions(hasActiveLicense = false) {
  const ids = hasActiveLicense ? [...RENEWAL_REQUEST_TYPES] : LICENSE_TYPE_IDS;
  return ids.map((id) => ({ id, label: LICENSE_TYPE_LABELS[id] || id }));
}

/** @param {string} licenseType @param {string} [validFrom] YYYY-MM-DD */
export function suggestedValidityDates(licenseType, validFrom) {
  const lt = String(licenseType || DEFAULT_ISSUED_LICENSE_TYPE).trim().toLowerCase();
  const start = validFrom ? new Date(`${validFrom}T12:00:00`) : new Date();
  const fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  const vf = fmt(start);
  const end = new Date(start);
  if (lt === LICENSE_TYPE_TRIAL_15_DAYS) {
    end.setDate(end.getDate() + 15);
    return { validFrom: vf, validTo: fmt(end) };
  }
  if (lt === LICENSE_TYPE_MONTHLY) {
    end.setMonth(end.getMonth() + 1);
    return { validFrom: vf, validTo: fmt(end) };
  }
  if (lt === LICENSE_TYPE_SEMIANNUAL) {
    end.setMonth(end.getMonth() + 6);
    return { validFrom: vf, validTo: fmt(end) };
  }
  if (lt === LICENSE_TYPE_COURTESY_PERMANENT) {
    return { validFrom: vf, validTo: COURTESY_PERMANENT_VALID_TO };
  }
  end.setFullYear(end.getFullYear() + 1);
  return { validFrom: vf, validTo: fmt(end) };
}
